import React from "react";
import { css } from "aphrodite";
import { inject } from "mobx-react";
import { appStore } from "src/mobx/AppStore";
import { Application } from "src/core/application";
import {styles} from "./TableauSponsorPageStyle";
import {dashboard_base} from "./Setting";


interface IPageProps {
    history: any
}




export class TableauSponsorPage extends React.Component<IPageProps> {
   private ref: any;

  constructor (props: IPageProps) {
	super(props);
    this.ref =React.createRef();
    	}


    public componentDidMount() {
    this.initViz();
    }
    public initViz() {
    const host_url =dashboard_base +"University_level_SPONSOR_DASH";
    const options ={
                     hideToolbar: true,
                     device: "desktop",
                     hideTabs: true,
                     embed: "yes",
                     onFirstInteractive: () => {console.log("Run this code when the viz has finished loading.")
                     const workbook = Viz.getWorkbook();
                     const activeSheet = workbook.getActiveSheet();
                     window.workbook =workbook;
                     window.activeSheet =activeSheet;
                     }
                }
    const Viz =new window.tableau.Viz(this.ref.current, host_url, options)
    }


    public render() {
        return (
               <div className={css(styles.dashContainer)}>
                <div  className ="tableauPlaceholder"  ref={this.ref}> </div>
               </div>
                );
    }
  }

export default TableauSponsorPage;
	  /*<div id ="vizContainer"  style={{display: 'none', width:'1366px', height:'768px'}} ref={this.ref}>
	        <script type="text/javascript">
            function exportToPDF() {
                  var viz = document.getElementById("vizContainer"),
                  viz.showExportPDFDialog();
                  }
            </script>
      <button onclick="exportToPDF();">Export to PDF</button>
	  <button onclick="exportToPDF();">Export to PDF</button>
	  <script type="text/javascript" src="https://vger.udel.edu/javascripts/api/viz_v1.js"> </script>
                	  <div className='tableauPlaceholder' style={{display: 'none', width:'1366px', height:'768px'}}>
                 	  <object className='tableauViz' width='1366px' height='768px' style={{display: 'none'}}>
                    <param name='host_url' value='https://vger.udel.edu/' />
                    <param name='site_root' value='' />
                    <param name='name' value='ResearchDashboard-demo-stable-2/University_level_SPONSOR_DASH' />
                    <param name='tabs' value='no' />
                    <param name='toolbar' value='no' />
                    <param name='showAppBanner' value='false' />
                    <param name='device' value='desktop'/>
                    </object>
                    </div>
      */



// WEBPACK FOOTER //
// ./src/pages/TableauSponsorPage.tsx